import React from 'react';

import {
  IconFileTypeXls,
  IconFileTypePdf,
  IconPhotoDown,
  IconFileTypeCsv,
  IconFileTypeTxt,
} from '@tabler/icons-react';
import { Tooltip } from 'react-tooltip';

interface DownloadDocumentButtonProps {
  downloadUrl?: string;
  onClick?: () => void;
  fileType: 'excel' | 'pdf' | 'image' | 'csv' | 'txt';
  tooltipText?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
  dataTooltipId?: string;
  disabled?: boolean;
}

export const DownloadDocumentButton: React.FC<DownloadDocumentButtonProps> = ({
  downloadUrl,
  onClick,
  fileType,
  tooltipText,
  tooltipPosition = 'left',
  disabled = false,
  dataTooltipId = 'download',
  className,
}) => {
  const renderIcon = () => {
    switch (fileType) {
      case 'excel':
        return <IconFileTypeXls stroke={2} />;
      case 'pdf':
        return <IconFileTypePdf stroke={2} />;
      case 'image':
        return <IconPhotoDown stroke={2} />;
      case 'csv':
        return <IconFileTypeCsv stroke={2} />;
      case 'txt':
        return <IconFileTypeTxt stroke={2} />;
      default:
        return null;
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    if (onClick && !disabled) {
      e.preventDefault();
      onClick();
    }
  };

  const disabledClassName = disabled
    ? 'cursor-not-allowed'
    : 'hover:border-pink-500 hover:bg-gray-900';

  return (
    <a
      href={downloadUrl || '#'}
      target="_blank"
      rel="noopener noreferrer"
      data-tooltip-id={`${dataTooltipId}-${fileType}`}
      className={`bg-transparent flex items-center justify-center rounded-md border border-transparent-0 p-2 text-white transition-all duration-300  ${disabledClassName} ${className}`}
      onClick={handleClick}
    >
      {renderIcon()}
      {tooltipText && !disabled && (
        <Tooltip
          id={`${dataTooltipId}-${fileType}`}
          className="max-w-[300px]"
          place={tooltipPosition}
        >
          {tooltipText}
        </Tooltip>
      )}
    </a>
  );
};
